export enum DocumentSidebarType {
  EXTERNAL_UPDATES = 'external_updates',
}

export enum DocumentSidebarTitle {
  EXTERNAL_UPDATES = 'External Updates',
}
